import {
  get
} from "lodash";
import {
  testMsg
} from "../test-apis";
import {
  isTestCompany
} from "../utils/auth";
import http from "../utils/http";
import {
  toast
} from "../utils/toast";

// OCR
export const ocrReceipt = (url) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg()
      reject();
      return
    }
    http
      .post(`/ocr/receipt`, {
        url
      })
      .then((res) => {
        toast.success('OCR 인식이 완료되었습니다.')
        resolve(get(res, 'data.data.images[0].receipt.result', res));
      })
      .catch((err) => {
        toast.error('OCR 인식 실패헀습니다.')
        reject(err);
      });
  });
};